import { render, staticRenderFns } from "./MDetailPrice.vue?vue&type=template&id=4a9138d3&scoped=true"
import script from "./MDetailPrice.vue?vue&type=script&lang=js"
export * from "./MDetailPrice.vue?vue&type=script&lang=js"
import style0 from "./MDetailPrice.vue?vue&type=style&index=0&id=4a9138d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9138d3",
  null
  
)

export default component.exports